// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-5e1792b0] .dx-toolbar h3 {\n  color: #999;\n}\n.results[data-v-5e1792b0] {\n  margin-left: 32px;\n  margin-right: 32px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
